import React from "react";
import GrowBagBg from "../../../certificates/GrowBagSetup.jpg";
const GrowBagSetup = () => {
  let serial = 1;
  return (
    <div>
      <h3
        style={{
          color: "green",
        }}
      >
        HYDROPONICS
      </h3>
      <h3 style={{ marginBottom: "-10px" }}>Grow Bag Setup</h3>
      <h3
        style={{
          marginBottom: "10px",
          color: "green",
          fontSize: "1.03rem",
        }}
      >
        as per guidelines of AIF Subsidy norms & ISI Standards.
      </h3>
      <p className="fs-3 mb-0">Specifications :</p>
      <table style={{ width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: "4%" }}>Sr.</th>
            <th style={{ width: "20%" }}>Item</th>
            <th style={{ width: "76" }}>Description / Specification</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{serial++}.</td>
            <td>Grow bags</td>
            <td>Duel layer grow bags with green/black outer colour.</td>
          </tr>
          <tr>
            <td>{serial++}.</td>
            <td>Bag length</td>
            <td>
              10 / 16 / 20 / 24 / 28 cm long bags (bag length is calculated
              after site inspection)
            </td>
          </tr>
          <tr>
            <td>{serial++}.</td>
            <td>Drip pipe</td>
            <td>
              16mm strong tensile drip pipes for watering the plants inside
              growbags.
            </td>
          </tr>
          <tr>
            <td>{serial++}.</td>
            <td>Other accessories</td>
            <td>Pump, piping, plumbing, fittings etc</td>
          </tr>
          <tr>
            <td>{serial++}.</td>
            <td>Walking distance</td>
            <td>
              Approximately 3.5 to 4.5 ft. walking distance will be maintained.
              So one labour with a crate can move freely.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Drip Plumbing System:</td>
            <td>
              Used in both hydroponic and soil-based protected farming, a drip
              plumbing system ensures efficient and precise delivery of water
              and nutrients directly to the plant root zone. It minimizes
              wastage and helps maintain optimal moisture levels. The system
              typically consists of UV-stabilized LDPE or HDPE pipes, with main
              lines of 16mm to 32mm and 4mm sublines. It operates under a
              pressure range of 1 to 2.5 bar and can be easily integrated with
              fertigation setups for consistent nutrient dosing.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Pressure-Controlled Join Nipple:</td>
            <td>
              This component is used to regulate pressure at individual dripper
              points, ensuring each plant receives uniform flow regardless of
              variations in elevation or line pressure. It connects microtubes
              to the mainline and prevents backflow or leakage, especially
              useful in long beds or uneven terrains. Most pressure-controlled
              nipples are designed to function optimally at 1–2 bar and are
              compatible with standard 4mm microtubes.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>4-Way Adapter:</td>
            <td>
              The 4-way adapter is a micro-irrigation splitter used to divert
              water from a single inlet into four separate microtubes, allowing
              four plants to be irrigated from one dripper or emitter. It is
              ideal for high-density cultivation in grow bags or Dutch buckets.
              Made of durable plastic, it is compatible with 4mm tubing and
              helps in simplifying plumbing layouts while reducing installation
              costs.
            </td>
          </tr>
          <tr>
            <td>{serial++}</td>
            <td>Arrow Dripper 4 LPH:</td>
            <td>
              An arrow dripper with a flow rate of 4 liters per hour (LPH) is
              designed for precise point irrigation in grow bags, pots, or
              containers. The arrow shape allows easy insertion into the media
              and ensures deep root watering. It delivers consistent output even
              under pressure variations and is ideal for crops like tomatoes,
              cucumbers, and capsicum in hydroponic systems. Typically operates
              at 1 to 1.5 bar pressure and is clog-resistant due to its
              labyrinth flow path.
            </td>
          </tr>
        </tbody>
      </table>
      <div style={{ width: "100%", marginTop: "20px" }}>
        <img src={GrowBagBg} width={"100%"} alt="kryzenCertificates" />
      </div>
      <div
        className="html2pdf__page-break"
        style={{ pageBreakAfter: "always", display: "block", clear: "both" }}
      ></div>
    </div>
  );
};

export default GrowBagSetup;
